<template>
    <div class="main_unit">
        <div class="top_unit">
            <div class="top_name_box">{{getStaffName}}</div>
            <div class="top_center_box"> </div>
        </div>
        <div class="main_unit">
            <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
            <div class=" wd976 tbl_ht_none tbl_bg_blue" v-show="!isInitLoading">

                <div v-if="validationMessage">
                    <Message :validationMessage="alertMessage" /><br>
                    <Message :validationMessage="validationMessage" />
                </div>

                <div class="right_btn_csv">
                    <a href="#" style="margin-bottom: 10px" @click.prevent.stop="csvOutput">CSV出力</a>
                </div>

                <table class="alert_tbl_unit_prm alert_tbl_unit_prm_height">
                    <tbody class="alert_tbl_unit_prm_scroll">
                        <tr>
                            <th class="wd140 alertList_text_align" rowspan="2">監視開始日時</th>
                            <th class="wd140 alertList_text_align" rowspan="2">異常発生日時</th>
                            <th class="wd140 alertList_text_align">異常復帰日時</th>
                            <th class="wd100_fix_min alertList_text_align" rowspan="2">設置名称</th>
                            <th class="wd120_fix_min alertList_text_align" colspan="2">異常内容</th>
                            <th class="wd80_fix_min alertList_text_align" rowspan="2">実測値</th>
                            <th class="wd140 alertList_text_align" rowspan="2">対処日時</th>
                            <th class="wd250 alertList_text_align">対処内容</th>
                            <th class="wd110_fix_min alertList_text_align " rowspan="2">担当</th>
                        </tr>
                        <tr>
                          <th class="border_top_none alertList_text_align">
                            <select id="clearingDateType" @change="changeClearingDateType" v-model="clearingDateType">
                              <option value="0" selected>全て</option>
                              <option v-for="(clearingDateType, index) in clearingDateTypes" :key="index+1" :value="index+1">{{clearingDateType}}</option>
                            </select>
                          </th>
                          <th class="border_top_none alertList_text_align" colspan="2">
                            <select id="alertType" @change="changeAlertType" v-model="type">
                              <option value="0" selected>全て</option>
                              <option v-for="(alertType, index) in alertTypes" :key="index+1" :value="index+1">{{alertType}}</option>
                            </select>
                          </th>
                          <th class="border_top_none alertList_text_align">
                            <select id="commentType" @change="changeCommentType" v-model="comment">
                              <option value="0" selected>全て</option>
                              <option v-for="(alertType, index) in commentTypes" :key="index+1" :value="index+1">{{alertType}}</option>
                            </select>
                          </th>
                        </tr>
                        <tr v-for="(alertList,index) in alertListData" :key="index">
                            <td class="wd140 alertList_text_align text_white_space alert_table_background-color">{{alertList.monitoringDate}} {{alertList.monitoringTime}}</td>
                            <td class="wd140 alertList_text_align text_white_space alert_table_background-color">{{alertList.detectionDate}} {{alertList.detectionTime}}</td>
                            <td class="wd140 alertList_text_align text_white_space alert_table_background-color">{{alertList.errorClearingDate}} {{alertList.errorClearingTime}}</td>
                            <td class="wd100_fix_min alertList_text_align text_white_space alert_table_background-color">{{alertList.location}}</td>
                            <td class="alertList_text_align text_white_space alert_table_background-color wd90">{{alertList.typeName}}</td>
                            <td class="alertList_text_align text_white_space alert_table_background-color wd90">{{alertList.statusName}}</td>
                            <td v-if="alertList.type == 1" class="wd80 alertList_text_align text_white_space alert_table_background-color">{{alertList.detectionTemperature}}</td>
                            <td v-else-if="alertList.type == 2" class="wd80 alertList_text_align text_white_space alert_table_background-color">{{alertList.detectionHumidity}}</td>
                            <td v-else class="wd80_fix_min alertList_text_align text_white_space alert_table_background-color"></td>
                            <td class="wd140 alertList_text_align text_white_space alert_table_background-color">{{alertList.commentDate}} {{alertList.commentTime}}</td>
                            <td v-if="alertList.comment!==null && alertList.comment!=='' && alertList.defalutCommentFlg == 1"  class="wd250 alert_table_background-color">
                                <textarea class="alert_textbox alert_table_background-color" placeholder="対応内容を入力"  maxlength="200" :value="alertList.comment"
                                          @focus="commnetFocus($event,index)" v-on:change="commnetInput($event,index)"  >
                                </textarea>
                            </td>
                            <td v-else class="wd250 alert_colspan_color">
                                <textarea class="alert_textbox alert_textbox_color " v-bind:class="{'alert_textbox_color_focus' : alertList.focustFlg}" placeholder="対応内容を入力" maxlength="200" :value="alertList.comment"
                                          @focus="commnetFocus($event,index)" @blur="commnetBlur($event,index)" v-on:change="commnetInput($event,index)"  >
                                </textarea>
                            </td>

                            <td class="wd110_fix_min alertList_text_align text_white_space alert_table_background-color">{{alertList.staffName}}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="btn_submit letter_spa">
                    <a href="#" role="button" @click.prevent.stop="sendCommentInput()" >登録</a>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="showContent">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit_s"></p>
                            <p class="modal_header_tit">警告詳細</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>対処内容の登録が完了しました。</p>
                    </div>
                    <div class="btn_submit_box">
                        <div class="btn_submit2">
                            <a role="button" @click.prevent.stop="closeModal()">閉じる</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="showContent2">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">CSV出力</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>CSV出力が完了しました。</p>
                    </div>
                    <div class="btn_submit">
                        <a href="#" @click.prevent.stop="closeCsvModel">OK</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay_loder" v-show="isLoading">
            <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        </div>
    </div>
</template>

<script>

    import PulseLoader from '@/app/components/PulseLoader.vue'
    import Message from '@/app/components/Message.vue'

    export default {
        name: 'AlertList',
        components: {
            PulseLoader,
            Message
        },
        computed:{
            getStaffName:function () {
                return  this.$store.getters['staff/name'];
            },
            brandPath: function () {
                return this.$store.getters['brand/path']
            },
        },
        data: function () {
            return {
                isInitLoading:true,
                validationMessage:"",
                alertMessage:'入力エラーがあります。',
                alertListData:[],
                showContent:false,
                showContent2:false,
                isLoading:false,
                type:0,
                alertTypes:["温湿度異常","機器異常・データ欠落"],
                comment:0,
                commentTypes:["対応済み","未入力"],
                clearingDateType:0,
                clearingDateTypes:["復帰","未復帰"]
            }
        },
        mounted () {

        },
        created: function(){
            this.calc();
        },
        methods:{
            calc:async function(){

                this.isInitLoading = true;

                // 企業ブランドIDの取得
                this.brandId = this.$store.getters['brand/id']
                // 店舗IDの取得
                this.storeId = this.$store.getters['store/id']

                ///user/brand/{brandId}/store/{storeId}/sensor_accident/history
              const params = {
                alertType: this.type,
                commentType: this.comment,
                clearingDateType: this.clearingDateType,
              };
                // DBデータ取得
                await this.$axios
                    .get(this.$apiEndpoint + 'user/brand/' + this.brandId + '/store/' + this.storeId + '/sensor_accident/history', {params})
                    .then(response => (this.alertListData = response['data']['sensorAccidentList']))
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        if (err.customError) {
                            error = Object.assign(error, err.customError)
                        }
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }).finally(()=> this.isInitLoading = false);

                // 表示パラメータの変換
                for(var i =0 ; i < this.alertListData.length ; i++){

                    var alertListDataList = this.alertListData[i];
                    // コメント編集の初期フラグを設定
                    alertListDataList.commentFlg = 0;
                    // フォーカス制御
                    alertListDataList.focustFlg = 0;

                    // typeの変換 アラート種別:1:温度異常、2:湿度異常、3:GW異常、4:機器異常、5:データ欠損
                    if(this.alertListData[i].type === 1){
                        alertListDataList.typeName = "温度"
                    }
                    else if(this.alertListData[i].type === 2){
                        alertListDataList.typeName = "湿度"
                    }
                    else if(this.alertListData[i].type === 3){
                        alertListDataList.typeName = "GW"
                    }
                    else if(this.alertListData[i].type === 4){
                        alertListDataList.typeName = "機器"
                    }
                    else if(this.alertListData[i].type === 5){
                        alertListDataList.typeName = "通信"
                    }
                    else{
                        alertListDataList.typeName = ""
                    }

                    // ステータスの変換 アラート詳細:1:上限、2:下限、3:電源、4:電池残1ヵ月、5:電池残3ヵ月、5:データ欠損
                    if(this.alertListData[i].status === 1){
                        alertListDataList.statusName = "上限"
                    }
                    else if(this.alertListData[i].status === 2){
                        alertListDataList.statusName = "下限"
                    }
                    else if(this.alertListData[i].status === 3){
                        alertListDataList.statusName = "電源"
                    }
                    else if(this.alertListData[i].status === 4){
                        alertListDataList.statusName = "電池残1ヵ月"
                    }
                    else if(this.alertListData[i].status === 5){
                        alertListDataList.statusName = "電池残3ヵ月"
                    }
                    else if(this.alertListData[i].status === 6){
                        alertListDataList.statusName = "データ欠落"
                    }
                    else{
                        alertListDataList.statusName = ""
                    }

                    this.alertListData.splice(i,1,alertListDataList);

                    // 温度、湿度の表示変換
                    if(this.alertListData[i].type === 1 && (this.alertListData[i].detectionTemperature !== null || this.alertListData[i].detectionTemperature !== "")){
                        this.alertListData[i].detectionTemperature = this.alertListData[i].detectionTemperature + "℃"
                    }
                    else if(this.alertListData[i].type === 2 && (this.alertListData[i].detectionHumidity !== null || this.alertListData[i].detectionHumidity !== "")){
                        this.alertListData[i].detectionHumidity = this.alertListData[i].detectionHumidity + "％"
                    }

                    // 初期コメントの有無判定
                    var resData = this.alertListData[i];
                    if(this.alertListData[i].comment !== null){
                        resData.defalutCommentFlg = 1;
                    }
                    else{
                        resData.defalutCommentFlg = 0;
                    }

                }
            },
            //フォーカスON時
            commnetFocus:function (event,index){

                var commnetList = this.alertListData[index];
                commnetList["focustFlg"] = 1;
                //配列に反映
                this.alertListData.splice(index,1,commnetList);
            },
            //フォーカスOFF時
            commnetBlur:function (event,index){

                var commnetList = this.alertListData[index];
                commnetList["focustFlg"] = 0;
                //配列に反映
                this.alertListData.splice(index,1,commnetList);
            },
            //コメント入力時の入力操作
            commnetInput:function (event,index){

                var textAreaData = event.target.value;
                var commnetList = this.alertListData[index];

                commnetList["commentFlg"] = 1;
                commnetList["comment"] = textAreaData;
                //配列に反映
                this.alertListData.splice(index,1,commnetList);
            },
            //更新処理
            async sendCommentInput(){

                this.isLoading = true;
                //バリデーションフラグ
                var validationFlg = true;
                //バリデーションチェック(桁数)
                this.validationMessage = '';
                var apiResponseFlg = true;

                for(var checkCount = 0 ; checkCount < this.alertListData.length ; checkCount++){
                    if(String(this.alertListData[checkCount].comment).length > 200){
                        this.validationMessage="対処内容は200桁以内で入力してください。"
                        validationFlg = false;
                        this.scrollTop();
                        break;
                    }
                }
                if(!validationFlg){
                    this.isLoading = false;
                    //処理終了
                    return null;
                }

                // 送信データの加工
                // ユーザ情報
                var staffId = this.$store.getters['staff/staffId'];
                var staffName = this.getStaffName;

                // コメント情報
                var alertRequestData = [];
                for(var listCount = 0 ; listCount < this.alertListData.length ; listCount++){
                    if(this.alertListData[listCount].commentFlg){
                        var alertRequestObj = new Object();
                        alertRequestObj['sensor_accident_id'] = this.alertListData[listCount].sensorAccidentId
                        alertRequestObj['comment'] = this.alertListData[listCount].comment
                        alertRequestData.push(alertRequestObj);
                    }
                }

                //機器異常コメント登録API呼び出し
                var brandId = this.$store.getters['brand/id'];
                var storeId = this.$store.getters['store/data'].store_id;
                var url = this.$apiEndpoint + 'user/brand/' + brandId + '/store/' + storeId + '/sensor_accident/comment' ;

                //更新API呼び出し
                await this.$axios
                    .post(url, {staff_id:staffId,staff_name:staffName,sensor_accident_list:alertRequestData})
                    .then()
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        apiResponseFlg = false;
                        this.isLoading = false;
                        this.scrollTop();
                        if (err.customError) {
                            error = Object.assign(error, err.customError);

                            if(error.code == 400){
                                this.validationMessage =  error.message;
                            }
                        }
                        if(error.code !== 400){
                            this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                        }
                    });

                // 処理エラーがない場合
                if(apiResponseFlg){
                    this.isLoading = false;
                    this.showContent = true;
                }
            },
            closeModal(){
                this.showContent = false;
                // 画面最新化
                this.calc();
            },
            scrollTop() {
                window.scrollTo(0,0);
            },
            //CSVファイル出力
            async csvOutput() {
                this.isLoading = true;
                this.ValidationMessage = '';
                let brandId = this.$store.getters['brand/id'];
                let storeId = this.$store.getters['store/id'];
                await this.$axios
                    .get(this.$apiEndpoint + 'user/brand/' + brandId + '/store/' + storeId + '/sensor_accident/csv/history')
                    .then(response => (this.csvResponseData = response))
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        if (err.customError) {
                            error = Object.assign(error, err.customError);

                            if(error.code == 400){
                                this.validationMessage =  error.message;
                                this.scrollTop();
                            } else if (error.code == 401) {
                                //店舗管理者のtokenエラーの場合
                                this.$cookies.set('user-api-token', '', 0)
                                this.$store.dispatch('store/doClear')
                            }
                        }
                        if(error.code !== 400){
                            this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                        }
                    }).finally(()=> this.isLoading = false);
                if(!this.commonDownloadCSV(this.csvResponseData)){
                    this.ValidationMessage =  "CSVの出力に失敗しました。";
                    this.scrollTop();
                }
                else{
                    this.showContent2 = true;
                }
            },
            closeCsvModel: function(){
                this.showContent2 = false;
            },
            //更新処理
            async changeAlertType(){
              //バリデーションチェック(桁数)
              this.validationMessage = '';
              //数値判定
              if(isNaN(this.type)) {
                this.validationMessage = '選択したアラート種別の形式が正しくありません';
                return null;
              }
              //選択肢内の数値判定
              if(this.type >= 0 && this.type <= this.alertTypes.length) {
                this.calc();
              } else {
                this.validationMessage = '選択したアラート種別の値が正しくありません';
              }
            },
            async changeCommentType(){
              //バリデーションチェック(桁数)
              this.validationMessage = '';
              //数値判定
              if(isNaN(this.comment)) {
                this.validationMessage = '選択した店舗対応の形式が正しくありません';
                return null;
              }
              //選択肢内の数値判定
              if(this.comment >= 0 && this.comment <= this.commentTypes.length) {
                this.calc();
              } else {
                this.validationMessage = '選択した店舗対応の値が正しくありません';
              }
            },
            async changeClearingDateType(){
              //バリデーションチェック(桁数)
              this.validationMessage = '';
              //数値判定
              if(isNaN(this.clearingDateType)) {
                this.validationMessage = '選択した異常復帰日時の形式が正しくありません';
                return null;
              }
              //選択肢内の数値判定
              if(this.clearingDateType >= 0 && this.clearingDateType <= this.clearingDateTypes.length) {
                this.calc();
              } else {
                this.validationMessage = '選択した異常復帰日時の値が正しくありません';
              }
            }
        }
    }
</script>

